import { ReactRenderer } from '@tiptap/react';
import tippy from 'tippy.js';
import Suggestion from '@tiptap/suggestion';
import { Extension } from '@tiptap/core';
import { MentionSuggestion } from '@/components/mention-suggestion';
import { PluginKey } from '@tiptap/pm/state';

// Create a unique plugin key for the mention suggestion
export const mentionSuggestionKey = new PluginKey('mentionSuggestion');

export const MentionExtension = Extension.create({
  name: 'mentionSuggestion',

  addOptions() {
    return {
      suggestion: {
        char: '@',
        pluginKey: mentionSuggestionKey,
        command: ({ editor, range, props }: any) => {
          // Delete the selection and insert the mention node
          const nodeAfter = editor.view.state.selection.$to.nodeAfter;
          const overrideSpace = nodeAfter?.text?.startsWith(' ');

          if (overrideSpace) {
            range.to += 1;
          }

          editor
            .chain()
            .focus()
            .deleteRange(range)
            .insertContent([
              {
                type: 'mention',
                attrs: {
                  id: props.id,
                  label: props.name,
                },
              },
              {
                type: 'text',
                text: ' ',
              },
            ])
            .run();
        },
        items: ({ query }: { query: string }) => {
          // We'll return an empty array here since the actual items
          // will be fetched and managed by the MentionSuggestion component
          return [];
        },
        render: () => {
          let component: ReactRenderer;
          let popup: any;

          return {
            onStart: (props: any) => {
              component = new ReactRenderer(MentionSuggestion, {
                props: {
                  ...props,
                  query: props.query,
                },
                editor: props.editor,
              });

              // Make sure the popup is appended to the body
              popup = tippy('body', {
                getReferenceClientRect: props.clientRect,
                appendTo: () => document.body,
                content: component.element,
                showOnCreate: true,
                interactive: true,
                trigger: 'manual',
                placement: 'bottom-start',
                arrow: false,
                zIndex: 9999,
              });
            },
            onUpdate: (props: any) => {
              component.updateProps({
                ...props,
                query: props.query,
              });

              popup[0].setProps({
                getReferenceClientRect: props.clientRect,
              });
            },
            onKeyDown: (props: any) => {
              if (!component.ref) return false;

              return (component.ref as any).onKeyDown(props);
            },
            onExit: () => {
              if (popup && popup[0]) {
                popup[0].destroy();
              }
              if (component) {
                component.destroy();
              }
            },
          };
        },
      },
    };
  },

  addProseMirrorPlugins() {
    return [
      Suggestion({
        editor: this.editor,
        ...this.options.suggestion,
      }),
    ];
  },
});
